<template>
  <div class="goods">
    <v-head :title="title" :route="'MemberCenter'"></v-head>
    <div class="content">
      <div class="order-box">
        <div style="text-align:center; padding:30px 0" v-if="loading">
          <van-loading size="24px" vertical>加载中...</van-loading>
        </div>
        <div v-else>
          <div class="warmTip" v-if="tableData.content && tableData.content.length<1">
            <img src="@/assets/images/404.png" />
            <span>暂无内容</span>
          </div>
          <ul v-else>
            <li class="box" v-for="item in tableData.content" :key="item.id">
              <div style="background-color: #fff;">
                <div>
                  <p class="title-p">
                    <span>申请时间：{{item.applyTime}}</span>
                    <span v-if="item.result==4"><i style="color:#f9a153">待审核</i></span>
                    <span v-if="item.result==1"><i>审核通过</i></span>
                    <span v-if="item.result==3"><i style="color: #ff4542;">退回修改</i></span>
                  </p>
                </div>
                <div class="Order">
                  <div class="justify-content">
                    <span>学生证有效期</span>
                    <span v-if="item.extendExpiryDate">{{item.extendExpiryDate|limitDate}}</span>
                  </div>
                  <div class="justify-content">
                    <span class="title">学生证明材料</span>
                    <span class="name" style="color:#107BDA;margin-left: 15px;"
                      @click="prevClick(item.seal)">{{item.fileName}}</span>
                  </div>
                  <div class="justify-content">
                    <span>审核通过时间</span>
                    <span v-if="item.auditSuccessTime">{{item.auditSuccessTime}}</span>
                  </div>
                  <div @click="lookreason(item.reason)" class="reason" v-if="item.result==3">
                    <p>
                      退回原因：{{item.reason}}
                    </p>
                  </div>
                  <div class="buttonBox">
                    <p>
                      <van-button @click="download(item.seal)" type="info" style="margin-right: 10px;">下载材料</van-button>
                      <van-button v-if="item.result==4||item.result==3" plain type="primary"
                        @click="edit(item)">修改重新提交</van-button>
                    </p>
                  </div>
                </div>
              </div>

            </li>
          </ul>
        </div>

        <van-image-preview v-model="showImg" :images="dialogImageUrl" :show-index='showIndex' :closeable='closeable'
          @close="onClose"></van-image-preview>
      </div>
    </div>
    <div class="bottomButton">
      <el-button plain type="primary" @click="apply()">点击申请延长有效期</el-button>
    </div>
  </div>
</template>
<script>
  import {
    getUser,
    applySubmit,
    applyReductionPage,
    downLoadFile,
    getBase64
  } from "@/api/dictionary";
  import vHead from "../../components/Subhead.vue";
  import { getSessionStore } from "@/utils/sessionStorage.js";
  import {
    Uploader,
    Toast,
    Button,
    ImagePreview,
    ActionSheet,
    Dialog,
    Loading,
  } from "vant";
  import { mapGetters, mapState, mapMutations } from "vuex";
  export default {
    data() {
      return {
        pay: false,
        loading: false,
        codeUrl: null,
        socket: null,
        dialogVisible: false,
        refresh: false,
        isShowPay: false,
        params: {
          pageSize: 10,
        },
        tableData: {},
        Id: '',
        page: 1,
        orderTip: "",
        payStatus: 0,
        checkedA: true,
        memberInfo: {},
        title: "申请记录",
        isWXPay: true,
        orderList: {
          content: [],
        },
        list: {
          content: [],
        },
        actived: 3,
        showBotton: false,
        showImg: false,
        dialogImageUrl: [],
        closeable: true,
        showIndex: false,
      };
    },
    components: {
      vHead,

      [Uploader.name]: Uploader,
      [Toast.name]: Toast,
      [Button.name]: Button,
      [ImagePreview.name]: ImagePreview,
      [ActionSheet.name]: ActionSheet,
      [Dialog.Component.name]: Dialog.Component,
      [Loading.name]: Loading,
    },
    computed: {
      ...mapGetters(["isGroupMember"]),
      ...mapState(["userInfo"]),
    },
    methods: {
      ...mapMutations(["setMemberInfo"]),
      onClose() {
        this.dialogImageUrl = [];
        this.showImg = false
      },
      prevClick(id) {
        getBase64({ id: id }).then(res => {
          this.dialogImageUrl[0] = res.result
          this.showImg = true
        });
      },
      cancel() {

      },
      getData() {
        this.params.memberId = sessionStorage.getItem("memberId")

        applyReductionPage(this.params, this.page - 1).then(res => {
          if (res.success) {
            this.tableData = res.result
          }
        })
      },
      isWithinThreeMonths(userInfo) {
        // 获取当前日期  
        var now = new Date();
        // 获取expiryDate的年份、月份和日期  
        var expiryDate = new Date(userInfo.expiryDate);
        // 将expiryDate转换为与当前日期相同的年份和月份，以便进行比较  
        expiryDate = new Date(expiryDate.getFullYear(), expiryDate.getMonth(), expiryDate.getDate());

        // 计算三个月后的日期  
        var threeMonthsLater = new Date(now.getFullYear(), now.getMonth() + 3, now.getDate());
        console.log('expiryDate', expiryDate >= threeMonthsLater, expiryDate, threeMonthsLater)
        // 比较expiryDate和三个月后的日期  
        if (expiryDate >= threeMonthsLater) {
          return true; // 距离有效期超过三个月  
        } else {
          return false; // 距离有效期还有三个月或更少  
        }
      },
      download(id) {
        this.openWindowWithToken(downLoadFile(id));
        // let url = this.reductiondownload + "?" + "id=" + id;
        // this.openWindowWithToken(url)
      },
      lookreason(reason) {
        this.$confirm(reason, "退回原因", {
          cancelButtonText: '关闭',
          type: "",
          showConfirmButton: false,
          showCancelButton: false
        }).then(() => {
        }).catch(() => { });
      },
      edit(row) {
        this.$router.push({ name: 'applyPage', query: { row: row, } });
      },
      apply() {
        // 检查是否存在待审核或退回修改记录
        let params = {
          memberId: sessionStorage.getItem("memberId")
        }
        applySubmit(params).then(res => {
          if (res.success) {
            this.$router.push({ name: 'applyPage' });
            this.disabled = false
          } else {
            this.$confirm(res.message, "提示", {
              cancelButtonText: '关闭',
              type: "warning",
              showConfirmButton: false
            }).then(() => {

            }).catch(() => { });
          }

        })
      }
    },

    mounted() {
      getUser().then((res) => {
        this.memberInfo = res.result;
        this.setMemberInfo(res.result);
      });
      this.getData()
    },
  };
</script>

<style lang="less" scoped>
  .warmTips {
    padding: 30px 0 40px 0;
  }

  .warmTips div>p {
    line-height: 22px;
    margin-bottom: 20px;
  }


  .reason {
    display: inline-block;
    padding: 10px;
    border-radius: 3px;
    background: rgb(255, 238, 238);
    width: 95%;
  }


  .reason>p {
    color: rgba(234, 15, 15, 1) !important;
    word-wrap: break-word;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }


  .Order {
    padding: 15px;
  }

  .Order .justify-content {
    line-height: 35px;
    color: #4f4f4f;
    font-size: 14px;
  }

  .Order .justify-content .title {
    display: inline-block;
    width: 100px;
  }

  .Order .justify-content .name {
    word-break: break-all;
    max-width: 230px;
  }

  .buttonBox {
    width: 100%;
    text-align: end;
    margin-top: 15px;
  }

  .title-p {
    padding: 15px 15px 0 15px;
    display: flex;
    justify-content: space-between;
  }

  .van-button {
    height: 28px !important;
  }

  .justify-content {
    display: flex;
    justify-content: space-between;
  }

  .bottomButton {
    width: 100%;
    position: fixed;
    bottom: 0;
    padding: 20px 0;
    text-align: center;
    background-color: #fff;
  }



  .box {
    padding-top: 10px;
    background-color: #efefef;
  }
</style>